// L06 · Rain (SPEC §3, Act II) — the first AI-judged level, now built on the shared
// judged-text shell (levels/textlevel.ts). "Describe the smell of rain. Do not use the
// word rain."
//
// The shell owns the crisis → precheck → abuse → judged pipeline (§10). L06 supplies the
// two things that are its own: the forbidden-word precheck (a local strike, no model call —
// §3), and the BOT-verdict → strike mapping. Only the free-text answer leaves the device.

import { textLevel } from "@/levels/textlevel.ts";
import { L06 as V } from "@/content/voice.ts";
import type { Level } from "@/levels/types.ts";

/** The forbidden word — matches rain, rains, raining, raincoat… but not brain/train/drain. */
const RAIN = /\brain/i;

export const L06: Level = textLevel({
  id: "L06",
  act: 2,
  title: "Rain",
  prompt: V.prompt,
  placeholder: V.placeholder,
  submit: V.submit,
  charLimit: V.charLimit,
  fallbacks: V.fallbacks,
  // The one forbidden word — local pre-check, a strike, no model needed (§3).
  precheck: (answer) =>
    RAIN.test(answer) ? { pass: true, strike: true, line: V.usedWord } : null,
  decide: (r, answer) => {
    const bot = r.verdict === "BOT";
    return {
      result: {
        pass: true,
        strike: bot,
        strikeReason: bot ? r.line : undefined,
        verdict: r.verdict,
        traits: r.traits,
        quote: r.exhibitWorthy ? answer : undefined,
        // line omitted: the beat already showed the verdict.
      },
    };
  },
});
